import * as actionTypes from '../actions/actionTypes';

const initialState = {
    dataValues: [],
    gender: [],
    race: [],
    defaultPhoneNo: [],
    maritalStatus: [],
    nationality: [],
    residentialStatus: [],
    country: [],
    licenceValidity: [],
    validation: [],
    myInfoRequestParamters: {},
    errorDropDownValidation: '',
    drivingLicenseManualClasses: [],
    residentialStatusManual: [],
    genderManual: [],
    drivingLicenseValidityManual: [],
    drivingLicenseClass: [],
    drivingLicenseStatus: [],
    otpSettings:[],
    myInfoSettings:[]
}

const getDropDownReducer = (state = initialState, action) => {

    switch (action.type) {
        case actionTypes.SET_DROPDOWN_DATA:
            return {
                ...state,
                [action.category]: action.value
            };
        case actionTypes.GET_DROPDOWN_DATA_FAILED:
            return {
                ...state,
                error: action.category,
                errorDropDownValidation: action.error
            }
        default: {
            return state;
        }
    }

}

export default getDropDownReducer;